module.exports = __webpack_public_path__ + "media/wyposazenie/bezpieczenstwo@3x-8b45cac0.svg";